import React from "react"; 
import './Learn.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
 
 

const Learn = ()=> {

 

    return (
        <>
            <AIheader/>

 

            {/* START techBannerMain */}
            <section className='techBannerMain'>
                <div className='container'>
                    <div className='techBannerOuter'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                                <div className='techBannerInner'>
                                    <h1><img className='img-fluid' src="/img/Technology/rentid_logo_white.svg" alt="rent id"/> Learn</h1>
                                    <p>Learn on your time,<br/> not your dime.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END techBannerMain */}
 
 
            {/* START supportPageMain */}
             <section className='supportPageMain learnPageMain'>
                 <div className='container'> 
                     <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                             <div className='supportPageInner supportPageLeft'>
                                <img className="img-fluid" src="/img/Learn/r_logo.svg" alt="rent id"/>
                                <h3>About Us</h3>
                                <p>Discover our mission, values, and how we  <br/>empower users with innovative solutions.</p>
                                <a href="/about-us" className="btn btnBlue">Explore</a>
                             </div>
                         </div>
                         <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                             <div className='supportPageInner supportPageRight'>
                                <img className="img-fluid" src="/img/Learn/laptop_video_lr.svg" alt="rent id"/>
                                <h3>Videos Library</h3>
                                <p>Browse helpful tutorials, guides, and <br/>insights to maximize your experience.</p>
                                <a href="/rentacademy#video-library" className="btn btnGrad_1">Coming Soon</a>
                             </div>
                         </div>
                         <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                             <div className='supportPageInner supportPageLeft'>
                                <img className="img-fluid" src="/img/Learn/question_lr.svg" alt="rent id"/>
                                <h3>Resource Center</h3>
                                <p>Essential tools and support to help <br/>hosts manage their rentals efficiently.</p>
                                <button type="button" className="btn btnGrad_1">Coming Soon</button>
                             </div>
                         </div>
                         <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                             <div className='supportPageInner supportPageRight'>
                                <img className="img-fluid" src="/img/Learn/book_edit_lr.svg" alt="rent id"/>
                                <h3>Blog</h3>
                                <p>Stay informed with industry insights, <br/>expert advice, and platform updates.</p>
                                <a href="/blogs" className="btn btnBlue">Explore</a>
                             </div>
                         </div>
                     </div>
                 </div>
             </section>
             {/* END generalConversationsMain */}
   
            <Footer/>
        </>
    )
}

export default Learn;